import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route, Link } from 'react-router-dom';
import urlConsts from './../../constants/urls';
import Footer from './../../containers/FooterContainer';
import Confirmation from './../commonComponents/confirmationBox';
import Welcome from './pages/welcome';
import IntroPage from './pages/introPage';
import About from './pages/about';
import IntroTutorial from './pages/tutorial'
import SimLogo from './../UiComponents/Logo';
import getLabel from './../../utils/labels'
import nextButton from '../../globals/images/next-button.svg';
import bgImage from './../../globals/images/intro-bg.png';
import bgImageDark from './../../globals/images/intro-bg-mask.png';
import styles from './Intro.module.scss';
import analyticsUtil from '../../utils/segmentUtils';

class Intro extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isConfirmationOpen: false
        }
    }

    openConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: true
        })
    }

    closeConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: false
        })
    }

    logout = () => {
        let logoutUrl = (this.props.logoutType === 'NORMAL') ? urlConsts.LOGOUT_URL : urlConsts.RETURN_URL
        analyticsUtil.reset()
        window.location = logoutUrl
    }


    welcome = (props) => {
        return <Welcome {...props} nextUrl={this.props.nextUrl} introductionData={this.props.introductionData} />
    }

    introPage = (props) => {
        return <IntroPage {...props} nextUrl={this.props.nextUrl} introductionData={this.props.introductionData} />
    }

    introTutorial = (props) => {
        return <IntroTutorial {...props} nextUrl={this.props.nextUrl} introductionData={this.props.introductionData} />
    }

    about = (props) => {
        return <About
            {...props}
            nextUrl={this.props.nextUrl}
            currentPageId={this.props.currentPageId}
            actors={this.props.actors}
            selfActor={this.props.uiState.selfActor}
            orgChart={this.props.uiState.orgChart}
            introductionData={this.props.introductionData}
        />
    }

    getHeader = (isIntroPage) => (<div className={styles['title-container']}>
        <div className={styles.title}><SimLogo /></div>
        {
            isIntroPage ?
                null
                :
                <div className={styles['intro-title']}>{getLabel('label_introduction_title')}</div>
        }
        <div className={styles['right-content-container']}>
            <p className={styles.logout} onClick={this.openConfirmationBox}>
                {
                    (this.props.logoutType === 'NORMAL')
                        ? getLabel('label_logout_button')
                        : getLabel('label_return_button')
                }
            </p>
        </div>
    </div>)

    render() {
        let { isConfirmationOpen } = this.state;
        const { match, prevUrl, nextUrl, renderPreviousButton, renderNextButton, logoutType } = this.props;

        let isFirstPage = match.path === '/' || match.path === '/welcome';
        let isIntroPage = match.path === '/intro' || isFirstPage;

        let nextButtonAnimationClassName = styles['next-button-image'];
        if (isIntroPage) {
            nextButtonAnimationClassName = styles['next-button-image-animated'];
        }

        let logoutButtonText = (logoutType === 'NORMAL') ? getLabel('label_logout_button') : getLabel('label_return_button');
        let logoutConfirmation = (logoutType === 'NORMAL') ? getLabel('label_logout_confirmation') : getLabel('label_return_confirmation');

        return (
            <Fragment>
                <div
                    className={styles['intro-container']}
                    style={isFirstPage ?
                        { backgroundImage: `url(${bgImageDark})` } :
                        { backgroundImage: `url(${bgImage})` }
                    }
                >
                    {this.getHeader(isIntroPage)}
                    < div className={styles['intro-wrapper']} >
                        <div className={styles['prev-button-container']}>
                            {
                                renderPreviousButton ?
                                    <Link to={prevUrl}>
                                        <img className={styles['prev-button']} src={nextButton} />
                                    </Link>
                                    :
                                    null
                            }
                        </div>
                        <div className={styles['intro-content']}>
                            <Route exact path={'/intro-tutorial'} component={this.introTutorial} />
                            <Route exact path={'/intro/:id'} component={this.about} />
                            <Route exact path={'/intro'} component={this.introPage} />
                            <Route exact path={'/welcome'} component={this.welcome} />
                            <Route exact path={'/'} component={this.welcome} />
                        </div>
                        <div className={styles['next-button-container']}>
                            {
                                renderNextButton ?
                                    <Link to={nextUrl}>
                                        <img
                                            src={nextButton}
                                            className={nextButtonAnimationClassName}
                                        />
                                    </Link>
                                    :
                                    null
                            }
                        </div>
                    </div >

                    <Footer isIntro={true} />
                </div >
                {
                    isConfirmationOpen ?
                        <Confirmation
                            acceptButtonText={logoutButtonText}
                            confimationMessage={logoutConfirmation}
                            onAcceptClick={this.logout}
                            onCancelClick={this.closeConfirmationBox}
                        />
                        :
                        null
                }
            </Fragment>
        )
    }
}

Intro.propTypes = {
};

Intro.defaultProps = {
}

export default Intro;


// WEBPACK FOOTER //
// /src/components/intro/Intro.js